import styled from '@emotion/styled'
import { InputHTMLAttributes } from 'react'
import * as React from 'react'

export type NumberInputProps = React.HTMLAttributes<HTMLInputElement> & {
  isError?: boolean
  max?: string | number
}

const StyledNumberInput = styled.input<NumberInputProps>`
  width: 100%;
  padding: 12px 8px;
  margin: 0;
  box-sizing: border-box;
  color: var(--Graphite);
  border: solid 1px var(--White80);
  vertical-align: middle;
  color: ${props => (props.isError ? '#e04925' : 'var(--Graphite)')};
  background: ${props => (props.isError ? '#fefbfb' : 'var(--White)')};
  &:focus-visible {
    outline: none;
  }
  &:disabled {
    background: var(--White96);
    color: var(--White40);
  }
`
export const NumberInput = ({ max, ...props }: InputHTMLAttributes<HTMLInputElement>) => (
  <StyledNumberInput {...props} max={max ?? '100'} min="0" step="0.01" type="number" />
)
